import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';

export default function TabMenu({ tabs, activeTab, onChange }) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        bgcolor: '#eaeef3',
        borderRadius: '9999px',
        p: 0.5,
        border: '1px solid #e2e8f0',
        position: 'relative'
      }}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <Box
            key={tab.id}
            component="button"
            onClick={() => onChange(tab.id)}
            sx={{
              position: 'relative',
              borderRadius: '9999px',
              px: { xs: 3, sm: 4.5 },
              py: 1,
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'Poppins',
              fontSize: { xs: '12px', sm: '13px' },
              fontWeight: 600,
              color: isActive ? '#ffffff' : '#64748b',
              bgcolor: 'transparent',
              outline: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              zIndex: 1,
              transition: 'color 0.25s ease',
              '&:hover': {
                color: isActive ? '#ffffff' : '#334155'
              }
            }}
          >
            {/* Tab Icon */}
            {tab.icon && (
              <Box
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  color: isActive ? '#ffffff' : '#64748b',
                  transition: 'color 0.25s ease',
                  '& svg': {
                    fontSize: '18px'
                  }
                }}
              >
                {tab.icon}
              </Box>
            )}

            {/* Tab Label */}
            <span>{tab.label}</span>

            {/* Active Pill Background Slide Animation */}
            {isActive && (
              <motion.div
                layoutId="activeTabBackground"
                transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: '#FF502D',
                  borderRadius: '9999px',
                  boxShadow: '0 4px 14px rgba(255, 80, 45, 0.35)',
                  zIndex: -1
                }}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
}
